import React from "react";

/**
 * Cijfers en codes (ordernummers, bedragen, aantallen) met vaste cijferbreedte,
 * zodat bedragen in een kolom onder elkaar uitlijnen.
 *
 * Geen apart font: `tabular-nums` vraagt de tabelcijfers op uit Montserrat zelf.
 * Eerder stond hier een monospace-stack met DM Mono uit het ontwerp, maar dat
 * gaf twee fonts in één CMS - en omdat dat webfont nooit geladen werd, viel het
 * per machine anders uit (SF Mono op de een, DM Mono op de ander).
 */
const Num = ({ children, muted, strong, size, align, nowrap = true, style, ...rest }) => (
  <span
    style={{
      fontVariantNumeric: "tabular-nums",
      fontSize: size || 13,
      fontWeight: strong ? 500 : 400,
      color: muted ? "rgba(0, 0, 0, 0.45)" : undefined,
      textAlign: align,
      whiteSpace: nowrap ? "nowrap" : undefined,
      display: align ? "block" : undefined,
      ...style,
    }}
    {...rest}
  >
    {children}
  </span>
);

export default Num;
